import React from 'react'

export default function LayoutsCoreUI(props) {
  return (

    <section><a className="anchor" id="core-ui"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
            <a href="samples/coreui.html"><img src="images/coreui.png" alt="Screenshot of the CORE UI snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-xs-6">
            <h2>Core UI</h2>
            Example of using -
            <ul>
	            <li><a href={props.staticVersion === true ? '#core/navigation' : 'Core#navigation'}>Navigation</a></li>
              <li><a href={props.staticVersion === true ? '#core/forms' : 'Core#forms'}>Forms</a></li>
              <li><a href={props.staticVersion === true ? '#core/buttons' : 'Core#buttons'}>Buttons</a></li>
              <li><a href={props.staticVersion === true ? '#core/grid' : 'Core#grid'}>Grid</a></li>
              <li><a href={props.staticVersion === true ? '#core/tables' : 'Core#tables'}>Tables</a></li>
              <li><a href={props.staticVersion === true ? '#components/environmentbanners' : 'Components#environmentbanners'}>Environment Banner</a></li>
            </ul>
            <p><a className="btn" href="samples/coreui.html">View live preview</a>&nbsp;<a className="btn" href="samples/coreui.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsCoreUI.js